<template>
  <v-footer v-if="show" class="cfs-sticky-footer" fixed>
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <slot />
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    zindex: {
      type: String,
      default: '5',
    },
  },
};
</script>
